import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import Organization from '@/repositories/data/Organization';
import HttpClient from '@/util/http/HttpClient';

export default class OrganizationRepository extends BaseCrudRepository<Organization, Organization, number> {
    constructor(client: HttpClient) {
        super(client, 'api/organizations/', 'CUSTOMERS');
    }
}
